import React, { useState, useRef } from "react";
import { Form, Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const SelectImageFromDevice = ({ uploadFunction, handleSelfClose }) => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);
  const [rotation, setRotation] = useState(0); // Rotation angle state
  const canvasRef = useRef(null); // Ref for the canvas element

  const handleImageUpload = (event) => {
    const file = event.target.files[0]; // Get the first selected file

    if (file) {
      const imageUrl = URL.createObjectURL(file); // Generate a temporary URL for the image
      setSelectedImage(imageUrl);

      // Optional: Revoke object URL to free memory when done
      return () => {
        URL.revokeObjectURL(imageUrl);
      };
    }
  };

  const rotateAndSaveImage = () => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const image = new Image();

    image.onload = () => {
      // Increment the rotation state
      const newRotation = 90 % 360;
      setRotation(newRotation);

      // Adjust canvas dimensions based on rotation
      if (newRotation % 180 === 0) {
        canvas.width = image.width;
        canvas.height = image.height;
      } else {
        canvas.width = image.height;
        canvas.height = image.width;
      }

      // Rotate the canvas
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.save();
      context.translate(canvas.width / 2, canvas.height / 2);
      context.rotate((newRotation * Math.PI) / 180); // Use the updated rotation value
      context.drawImage(
        image,
        -image.width / 2,
        -image.height / 2,
        image.width,
        image.height
      );
      context.restore();

      // Save the rotated image as a new file
      const rotatedImageUrl = canvas.toDataURL("image/jpeg");
      setSelectedImage(rotatedImageUrl); // Update the displayed image
    };

    image.src = selectedImage;
  };

  return (
    <div className="d-flex flex-column align-items-center mt-4">
      <Card style={{ width: "400px", padding: "20px" }}>
        <Card.Body>
          <Card.Title>{t("SelectPhoto")}</Card.Title>
          <Form>
            {/* File Input */}
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>{t("SelectImageFromDevice")}</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
              />
              {/* Submit Button */}
              <br />
              <Button
                variant="primary"
                onClick={() => {
                  uploadFunction(selectedImage);
                  handleSelfClose();
                }}
              >
                {t("Save")}
              </Button>
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>

      {/* Preview Section */}
      {selectedImage && (
        <Card className="mt-4" style={{ width: "300px" }}>
          <Card.Img
            variant="top"
            src={selectedImage}
            alt="Selected"
            style={{ objectFit: "contain", height: "300px" }}
          />
          <Card.Body>
            <Button variant="secondary" onClick={rotateAndSaveImage}>
              {t("Rotate")} 90°
            </Button>
            <Card.Text className="mt-3">{t("ImageChosenProceed")}.</Card.Text>
          </Card.Body>
        </Card>
      )}
      {/* Canvas (Hidden) */}
      <canvas ref={canvasRef} style={{ display: "none" }} />
    </div>
  );
};

export default SelectImageFromDevice;
